export default "__VITE_ASSET__CdYoEJFM__"